<script>
    import R, {LOADER} from "../lib/requests";
    import Modal from '../components/modal/Modal.svelte';
    import Checkbox from "../components/controls/Checkbox.svelte";
    import ChargeComponent from "../charges/ChargeComponent.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import {formatDate, getMonthsDiff, getTimeFromDate, setFocusOut, setFocusTo} from "../lib/lib";
    import {OBJECTS} from "../lib/constants";
    import Notifier from "../stores/notifier";

    export let serviceId = null;
    export let subscriptionId = null;
    export let closeCallback;

    let title = "Ανανέωση";
    let service = null;
    let wsService = null;
    let subscription = null;
    let charge = null;
    let sendNotification = null;


    const initialize = () => {
        load();
    }

    const load = () => {

        const onSuccess = result => {
            service = result.service;
            wsService = result.ws_service;
            if (subscriptionId > 0) {
                subscription = result.subscription;
                if (subscription.charge_id > 0) {
                    charge = result.charge;
                }
                // set service duration from subscription dates
                service.duration = getMonthsDiff(subscription.start_at, subscription.end_at);
                title = "Συνδρομή";
            } else {
                // renew subscription data
                if (result.subscription) {
                    subscription = result.subscription;
                    subscription.id = 0;
                    subscription.service_id = service.id;
                    subscription.start_at = subscription.end_at;
                } else {
                    subscription = {
                        id: 0,
                        service_id: service.id,
                        price: service.price,
                        start_at: formatDate(new Date, 'y-m-d'),
                        end_at: null,
                        notes: null,
                    }
                }
            }

            // let notification = result.notifications.find(x => x.type == 3);
            // if (notification && notification.is_active) {
            //     sendNotification = 1;
            // }
            setExpirationDate();
        };

        const onFailure = err => {
        };

        // R.handle(R.service.details, serviceId, onSuccess, onFailure, LOADER.POPUP);
        if (!subscriptionId) {
            R.handle(R.subscription.new, serviceId, onSuccess, onFailure, LOADER.POPUP);
        } else {
            R.handle(R.subscription.details, subscriptionId, onSuccess, onFailure, LOADER.POPUP);
        }
    };

    const close = (param) => {
        subscription = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }


    const save = () => {
        const onSuccess = result => {
            subscription = result;
            if (charge) {
                saveCharge();
            } else {
                close(subscription);
            }
        }

        const onFailure = err => {
        };

        if (service.duration < 1) {
            Notifier.showError("Δεν έχετε ορίσει την διάρκεια της συνδρομής!");
            setFocusTo('duration');
            return;
        }

        if (!subscription.start_at) {
            Notifier.showError("Δεν έχετε ορίσει την ημερομηνία έναρξης της συνδρομής!");
            setFocusTo('startAt');
            return;
        }

        if (!subscription.end_at) {
            Notifier.showError("Δεν έχετε ορίσει την ημερομηνία λήξης της συνδρομής!");
            setFocusTo('endAt');
            return;
        }

        if (sendNotification == 1) {
            subscription.send_notification = 1;
        }

        let action = subscription.id > 0 ? 'edit' : 'create';
        R.handle(R.subscription[action], subscription, onSuccess, onFailure, LOADER.POPUP);
    }

    initialize();


    const setExpirationDate = () => {
        // if (wsService && service.subscription.start_at) {
        if (subscription.start_at) {
            let start = new Date(subscription.start_at);
            subscription.end_at = formatDate(start.addMonths(~~service.duration), 'y-m-d');
        }
    }

    /* Subscription charge handlers */
    const showCharge = () => {
        charge = {
            id: 0,
            object_type: OBJECTS.SUBSCRIPTION,
            client_id: service.client_id,
            name: '',
            price: subscription.price || null,
            payment: null,
        }
    }

    const onDeleteCharge = () => {
        if (charge && charge.id > 0) {
            Alert.confirm("Αφαίρεση χρέωσης", "Να αφαιρεθεί η χρέωση της συνδρομής;", deleteCharge);
            return;
        }

        charge = null;
    }

    const deleteCharge = () => {

        const onSuccess = result => {
            charge = null;
        }

        const onFailure = err => {
        };

        R.handle(R.charge.delete, charge.id, onSuccess, onFailure, LOADER.POPUP);
    }

    const saveCharge = () => {
        const onSuccess = result => {
            subscription.charge_id = result.id;
            close(subscription);
        }

        const onFailure = err => {
        };

        charge.object_id = subscription.id;

        let action = charge.id > 0 ? 'edit' : 'create';
        R.handle(R.charge[action], charge, onSuccess, onFailure, LOADER.POPUP);
    }

    $: {
        if (subscription && charge) {
            charge.name = `${wsService.name} ${service.name} (${formatDate(subscription.start_at, 'd/m/y')} - ${formatDate(subscription.end_at, 'd/m/y')})`;
            charge.price = subscription.price;
        }
    }

</script>

{#if subscription}
    <Modal {title} bodyClass="pt-0" closeOnEscape="{ true }" on:close="{ close }">
        <div slot="body">
            <div class="service-type">{ wsService.name }</div>
            <h5 class="mb-4">{ service.name }</h5>

            <div class="row">
                <div class="col-6 form-group">
                    <label>Διάρκεια (μήνες)</label>
                    <input type="number" class="form-control" id="duration" bind:value="{ service.duration }"
                           on:change="{ setExpirationDate }" required>
                </div>
                <div class="col-6 form-group">
                    <label>Τιμή</label>
                    <input type="text" class="form-control" bind:value="{ subscription.price }">
                </div>
            </div>

            <div class="row">
                <div class="col-lg-6 form-group">
                    <label>Έναρξη</label>
                    <input type="date" class="form-control" id="startAt" bind:value="{ subscription.start_at }"
                           required
                           on:change={ setExpirationDate }>
                </div>
                <div class="col-lg-6 form-group">
                    <label>Λήξη</label>
                    <input type="date" class="form-control" id="endAt" bind:value="{ subscription.end_at }"
                           required>
                </div>
            </div>
            <div class="form-group">
                <textarea class="form-control" bind:value="{ subscription.notes }" placeholder="σημειώσεις"></textarea>
            </div>
            {#if sendNotification != null}
                <div class="form-group">
                    <Checkbox label="Αποστολή ειδοποίησης ανανέωσης" bind:checked={ sendNotification }/>
                </div>
            {/if}

            {#if charge == null}
                <button class="btn btn-default btn-block btn-sm" on:click={showCharge}>Δημιουργία χρέωσης</button>
            {:else}
                <div class="panel panel-default">
                    <div class="panel-heading fw-semibold pe-0">
                        <h6 class="mb-0">Στοιχεία χρέωσης</h6>
                        <button class="btn" on:click={onDeleteCharge}>
                            <AppIcon icon="x" strokeWidth="2"/>
                        </button>
                    </div>
                    <div class="panel-body pt-3">
                        <ChargeComponent bind:charge disableName disablePrice/>
                    </div>
                </div>
            {/if}

            <hr class="full-hr">
            <div class="text-end">
                <div class="btn btn-link" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary" on:click={ save }>{ subscriptionId > 0 ? "Ενημέρωση" : "Ανανέωση"}</button>
            </div>
        </div>
    </Modal>
{/if}

<style>
    .service-type {
        line-height: 1;
    }
</style>